import { Component, OnInit } from '@angular/core';
import { LoginUnawareComponent } from '../login-unaware-component';
import { GraphClientService } from '../services/graph-client-service';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

const MAX_NUMBER_OF_ITEMS = 5;

/**
 * Displays a strip of links and icons at the bottom of the page. The icons and links
 * are sourced from a SharePoint Online list.
 */
@Component({
  selector: 'app-service-directory',
  templateUrl: './service-directory.component.html',
  styleUrls: ['./service-directory.component.scss']
})
export class ServiceDirectoryComponent extends LoginUnawareComponent implements OnInit {
  public services: any[];

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService) {
    super(diagnosticsFactory.create('ServiceDirectoryComponent'));
    this.services = [];
  }

  ngOnInit() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;
        const allItems = dynamicData.value;
        allItems.sort((left, right) => left.fields.SortOrder - right.fields.SortOrder);

        if (allItems.length > MAX_NUMBER_OF_ITEMS) {
          this.diagnostics.logWarning(`The number of items returned by data service exceeds the ` +
            `max. value of ${MAX_NUMBER_OF_ITEMS} items that can be displayed. The rest of the items are ignored.`);
          this.services = allItems.slice(0, MAX_NUMBER_OF_ITEMS);
        } else {
          this.services = allItems;
        }
      }, error => {
        this.diagnostics.logError(`Error loading data. Details: ${JSON.stringify(error)}`);
      });
  }
}
